const getAddressFromSuggestions = (suggestions, id)=>{
    const suggestion1 = suggestions.find((suggestion)=>suggestion.id === id
    );
    const { title ='' , subTitle  } = suggestion1 !== null && suggestion1 !== void 0 ? suggestion1 : {};
    return `${title}${subTitle ? ', ' + subTitle : ''}`;
};

export { getAddressFromSuggestions };
//# sourceMappingURL=get-address-from-suggestions.js.map
